export default "__VITE_ASSET__seRJEtao__"